import {
    bundleIcon,
    DismissFilled,
    DismissRegular,
    MailArrowForwardFilled,
    MailArrowForwardRegular,
    MailCopyFilled,
    MailCopyRegular,
} from '@fluentui/react-icons'

/**
 * What processing an e-mail does to the file references it carries. Shared by the three hosts of the process-e-mail
 * form: the e-mail tab of a file, the global inbox and the suggestion popup the inboxer raises (HAM-4278).
 */
export enum EmailProcessingAction {
    Copy = 'COPY',
    Move = 'MOVE',
    File = 'FILE',
    Ignore = 'IGNORE',
}

export const EmailProcessingActionLabelMap = new Map([
    [EmailProcessingAction.Copy, 'action.copy'],
    [EmailProcessingAction.Move, 'action.move'],
    [EmailProcessingAction.File, 'action.file'],
    [EmailProcessingAction.Ignore, 'action.not_file'],
])

export const EmailProcessingActionIconMap = new Map([
    [EmailProcessingAction.Copy, bundleIcon(MailCopyFilled, MailCopyRegular)],
    [EmailProcessingAction.Move, bundleIcon(MailArrowForwardFilled, MailArrowForwardRegular)],
    [EmailProcessingAction.File, bundleIcon(MailArrowForwardFilled, MailArrowForwardRegular)],
    [EmailProcessingAction.Ignore, bundleIcon(DismissFilled, DismissRegular)],
])
